import {z} from 'zod';
import {CreateRepairDocumentRequest} from '../api/generated/index.defs';
import {mapNullToUndefined} from '../utils/zod.ts';

export const repairDocumentSchema = z.object({
  url: z.string(),
  fileName: z.string(),
  name: mapNullToUndefined(z.string().optional()),
  sortOrder: mapNullToUndefined(z.number().optional()),
  description: mapNullToUndefined(z.string().optional()),
  type: mapNullToUndefined(z.string().optional()),
}) satisfies z.Schema<CreateRepairDocumentRequest>;
export type RepairDocumentSchema = z.TypeOf<typeof repairDocumentSchema>;
